import {PaymentMethod} from "./protocol";

export enum LoginStatus {
    INITIAL_NOT_AUTHENTICATED,
    LOGGED_OUT,
    IN_PROGRESS,
    LOGGED_IN,
    LOGIN_ERROR,
    VERIFICATION_REQUIRED,
    MFA_VERIFICATION_REQUIRED,
    MFA_VERIFICATION_ERROR,
    ACCEPT_TERMS_REQUIRED,
    MANUAL_APPROVAL_REQUIRED
}
export interface SettingsUrl {
    baseUrl : string;
}
export interface ManifestUrl {
    apple_icon_url : string;
}
export enum Status {
    SUCCESS = "SUCCESS",
    SCREEN_NAME_EXIST = "SCREEN_NAME_EXIST",
    EMAIL_EXIST = "EMAIL_EXIST",
    INVALID_DATA = "INVALID_DATA",
}
export enum ResetPasswordStatus {
    NOT_USED, IN_PROGRESS, ERROR, SENT
}
export enum RequestCashbackStatus {
    IN_PROGRESS, ERROR, SUCCESS
}
export enum VerifyPrincipalStatus {
    NOT_USED, IN_PROGRESS, ERROR, SENT, COMPLETE, READY
}
export type PaymentMehtodsByCurrency = {[key:string]: PaymentMethod[]};

export type PriorityType = "low"|"medium"|"high";

export enum AcceptedRoutes {
    CASINO = "casino",
    POKER = "poker",
    SPORT = "sportsbook",
    RACING = "racing"
}

export enum searchParams {
    REF = 'ref',
    BTAG = 'btag',
    CA = 'ca',
    CH = 'ch',
    SRC = 'src',
    CUR = 'cur',
    CLICK_ID = 'click_id'
}